import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { RequestService } from '../services/requests.services';
import { NgForm, FormControl } from '@angular/forms';
import { UserInformation } from '../Model/userInformation'
import { Reviewer } from '../Model/reviewer'
import { ReviewRequest } from '../Model/reviewRequest'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Task } from '../Model/task';
import { Project } from '../Model/project';
import { ReviewRequestType } from '../../common/requestType';
import { ReviewRequestJustificationType } from '../../common/reviewRequestJustificationType';
import url from 'src/settings.json';
import { Setting } from '../../common/settings';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import { MatDialog } from '@angular/material/dialog';
import { TaskQueryComponent } from './task-query/task-query.component';
import { TextService } from 'src/app/common/text.service';

export interface QueryDialogData {
  currentUser: string;
  organisation: string;
  project: string;
  selectedTasks: Array<Task>;  
}

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})

export class CreateComponent implements OnInit, OnDestroy {
  reviewerControl = new FormControl();
  moderatorControl = new FormControl();
  taskControl = new FormControl();  
  projects: Project[] = [];
  isTaskLoading = false;
  isReviewerLoading = false;
  isModeratorLoading = false;  
  setting: Setting = url;
  currentOrganisation: any;
  organisationSubscriber?: Subscription;
  dialogSubscription?: Subscription;
  projectSubscription?: Subscription;
  currentUserSubscription?: Subscription;
  teamMembersSubscription?: Subscription;
  createRequestSubscription?: Subscription;
  isError = false;
  errorMessage!: string;
  reviewerIds: Array<string> = [];
  moderatorIds: Array<string> = [];
  isReviewerAlreadySelected = false;
  isModeratorAlreadySelected = false;
  currentUser!: UserInformation;
  isRequestor = false;
  isRequestCreatedSuccessfully = false;
  isrequestCreating = false;
  minDate = new Date();
  isRequestSubmitted = false;
  submitted = false;
  isNoTaskFound = false;
  isNoReviewerFound = false;
  isNoModeratorFound = false;
  isDuplicateTask = false;

  reviewRequest: ReviewRequest = {
    requestType: ReviewRequestType.Unsupported,
    justificationType: ReviewRequestJustificationType.NotApplicable,
    title: '',
    deadline: new Date(),
    notificationMessage: '',
    moderators: [],
    tasks: [],
    project: '',
    reviewers: []
  }

  reviewRequests: Array<ReviewRequest> = [];
  API_BASE_URL: string = this.setting.url;  
  reviewers: Array<Reviewer> = [];
  opts: Array<UserInformation> = [];
  filteredOptions!: Observable<any>;

  moderators: Array<Reviewer> = [];
  moderatorOptions: Array<UserInformation> = [];
  moderatorfilteredOptions!: Observable<any>;

  taskList: Array<Task> = [];
  tasksOptions: Array<Task> = [];
  tasksfilteredOptions!: Observable<any>;

  checked = false;
  @ViewChild('requestForm', { static: false })
  signupForm!: NgForm;
  init:any;

  constructor(private readonly service: RequestService,
    private readonly http: HttpClient,
    private readonly organisationService: OrganisationService, public queryDialog: MatDialog, private readonly Init:TextService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    this.GetCurrentUser();
  }
  ngOnDestroy(): void {
    this.organisationSubscriber?.unsubscribe();
    this.dialogSubscription?.unsubscribe();
    this.projectSubscription?.unsubscribe();
    this.currentUserSubscription?.unsubscribe();
    this.teamMembersSubscription?.unsubscribe();
    }

  ngOnInit(): void { 
    this.init = this.Init.getEditorInit();   
    this.filteredOptions = this.reviewerControl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter((value) => value !== ""),
      switchMap(val => {
        this.isNoReviewerFound = false;
        return this.filterReviewers(val);        
      }))

    this.moderatorfilteredOptions = this.moderatorControl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter((value) => value !== ""),
      switchMap(val => {
        return this.filterModerators(val)
      }))

    this.tasksfilteredOptions = this.taskControl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter((value)=>value !== ""),
      switchMap(val => {
        return this.filterTasks(val)
      }))

    this.getProjects();    
  }

  openQueryDialog(): void {
    const dialogRef = this.queryDialog.open(TaskQueryComponent, {
      data: { currentUser: this.currentUser, organisation: this.currentOrganisation, project: this.signupForm.value.requestData.project, selectedTasks: this.taskList },
      width: '100%',
      height:'80%'
    });   

    this.dialogSubscription=dialogRef.afterClosed().subscribe(result => {      
      this.taskList = result;
    });
  }

  filterReviewers(val: string): Observable<UserInformation[]> {
    // call the service which makes the http-request
    this.isReviewerLoading = true;
    return this.getData(val,'reviewer')
      .pipe(
        map(response => response.filter((option: UserInformation) => {          
          return option.displayName;
        }))
      )
  }

  filterModerators(val: string): Observable<UserInformation[]> {
    this.isModeratorLoading = true;
    this.isNoModeratorFound = false;
    return this.getData(val,'moderator')
      .pipe(
        map(response => response.filter((option: UserInformation) => {          
          return option.displayName;
        }))
      )
  }

  filterTasks(val: string): Observable<Task[]> {
    // call the service which makes the http-request
    this.isNoTaskFound = false;
    return this.getTasks(val)
      .pipe(
        map(response => response?.filter((option: Task) => {          
          return option.title;
        })))

  }

  getData(val: string, role: string) {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const searchTerm = new HttpParams().set('searchTerm', val);

    if (val === "") {
      this.opts = [];
      return of(this.opts);
    }
    else {
      return this.http.get<UserInformation[]>(`${url}/api/user/`, { params: searchTerm }).pipe(tap(data => {
        if (data == null || data.length === 0) {
          if (role === 'reviewer') {
            this.isNoReviewerFound = true;
          }
          else {
            this.isNoModeratorFound = true;
          }            
        }

        this.opts = data
        if (role === 'reviewer') {
          this.isReviewerLoading = false;
        }
        else {
          this.isModeratorLoading = false;
        }
        
      }))
    }
  }

  getTasks(val: string) {
    this.isTaskLoading = true;
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const proj = this.signupForm.value.requestData.project;
    const term = new HttpParams().set('term', val).set('project', proj);
    
    if (val === "") { this.tasksOptions = []; return of(this.tasksOptions); }
   
    return this.http.get<Task[]>(`${url}/api/tasks/`, { params: term }).pipe(tap(data => {
      if (data == null) {
        this.isNoTaskFound = true;
        this.errorMessage = "No task found!";
      }

      this.tasksOptions = data;
      this.isTaskLoading = false;
    }))
  }

  getProjects() {
    this.projectSubscription=this.service.getProjects().subscribe({
      next: (response: Project[]) => {
        this.projects = response;        
      },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
      },
      complete: () => { }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.taskList.length > 0 && this.reviewers.length > 0) {
      this.isError = false;
      this.reviewRequest.title = this.signupForm.value.requestData.title;
      this.reviewRequest.project = this.signupForm.value.requestData.project;
      this.reviewRequest.requestType = this.signupForm.value.requestData.requestType;
      this.reviewRequest.justificationType = this.signupForm.value.requestData.justificationType === undefined ? "NotApplicable" : this.signupForm.value.requestData.justificationType;      
      this.reviewRequest.reviewers = this.reviewers;
      this.reviewRequest.deadline = this.signupForm.value.requestData.deadline;
      this.reviewRequest.moderators = this.moderators;
      this.reviewRequest.tasks = this.taskList;
      this.reviewRequest.notificationMessage = this.signupForm.value.requestData.notificationMessage;     
      this.createReviewRequest(this.reviewRequest);
    }
    else {      
      this.isError = true;
      this.errorMessage = "Either task or reviewer is not selected";
      this.submitted = false;
    }
    
  }

  onSelected(event: MatAutocompleteSelectedEvent) {
    this.isReviewerAlreadySelected = false;
    var user = this.opts.find(x => x.adsId === event.option.value) as UserInformation;
    
    if (user.isContainer) {
      const proj = this.signupForm.value.requestData.project;
      this.teamMembersSubscription=this.service.getTeamMembers(user.adsId, proj).subscribe({
        next: (data) => {
          //for (let i = 0; i < data.length; i++) {
          //  this.pushToReviewersArray(new Reviewer(new UserInformation(data[i].adsId, data[i].displayName), true, ''));
          //}
          for (let reviewer of data) {
            this.pushToReviewersArray(new Reviewer(new UserInformation(reviewer.adsId, reviewer.displayName), true, ''));
          }
        }
      })
    }
    else {      
      this.pushToReviewersArray(new Reviewer(new UserInformation(event.option.value, user.displayName), true, ''));
    }    
    this.opts = [];    
    this.reviewerControl.setValue("");
    event.option.value = '';
  }

  pushToReviewersArray(reviewer: Reviewer) {
    var addUser = false;
    var currentUserAdsId = this.currentUser.adsId;
    this.isRequestor = false;
    this.isReviewerAlreadySelected = false;

    if (currentUserAdsId === reviewer.user.adsId) { 
      this.isRequestor = true;
      return;
    }

    if (this.moderatorIds.indexOf(reviewer.user.adsId) >= 0) {
      this.isReviewerAlreadySelected = true;
      return;
    }

    if (this.reviewerIds.indexOf(reviewer.user.adsId) >= 0) {
      return;
    } else {
      addUser = true;      
    }

    if (addUser) {
      this.reviewerIds.push(reviewer.user.adsId);
      this.reviewers.push(reviewer);
    }
  }

  onModeratorSelected(event: MatAutocompleteSelectedEvent) {
    this.isModeratorAlreadySelected = false;
    var user = this.opts.find(x => x.adsId === event.option.value) as UserInformation;
    console.log(user);    
    this.pushToModeratorsArray(new Reviewer(new UserInformation(event.option.value, user.displayName), true, 'NA'));
    this.moderatorControl.setValue("");
    this.opts = [];
    event.option.value = '';
  }

  pushToModeratorsArray(moderator: Reviewer) {
    var addModerator = false;
    this.isRequestor = false;
    this.isModeratorAlreadySelected = false;

    if (this.currentUser.adsId === moderator.user.adsId) {
      this.isRequestor = true;
      return;
    }

    if (this.reviewerIds.indexOf(moderator.user.adsId) >= 0) {      
      this.isModeratorAlreadySelected = true;
      return;
    }

    if (this.moderatorIds.indexOf(moderator.user.adsId) >= 0) {
      return;
    } else {
      addModerator = true;      
    }

    if (addModerator) {
      this.moderatorIds.push(moderator.user.adsId);
      this.moderators.push(moderator);
    }
  }

  GetCurrentUser() {
    this.currentUserSubscription=this.service.getCurrentUser().subscribe({
      next: (user: UserInformation) => {
        this.currentUser = user;
      },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;        
      },      
      complete: () => { }
    });
  }
  onTaskSelected(event: MatAutocompleteSelectedEvent) {
    this.isDuplicateTask = false;
    if (this.taskList.find(t => t.id === event.option.value) === undefined) {
      var task = this.tasksOptions.find(x => x.id === event.option.value) as Task;
      console.log(task);
      this.taskList.push(new Task(task.shortType, event.option.value, task.title));
    } else {
      this.isDuplicateTask = true;
      this.errorMessage = "This task is already selected!";
    }

    this.tasksOptions = [];
    this.taskControl.setValue("");
    event.option.value = '';
  }

  removeTask(task: Task) {
    const index = this.taskList.indexOf(task);
    this.taskList.splice(index, 1);
  }

  removeReviewer(reviewer: Reviewer) {
    const index = this.reviewers.indexOf(reviewer);
    const indexId = this.reviewerIds.indexOf(reviewer.user.adsId);
    this.reviewerIds.splice(indexId, 1);
    this.reviewers.splice(index, 1);
  }

  removeModerator(moderator: Reviewer) {
    const index = this.moderators.indexOf(moderator);
    const indexId = this.reviewerIds.indexOf(moderator.user.adsId);
    this.moderatorIds.splice(indexId, 1);
    this.moderators.splice(index, 1);
  }
  createReviewRequest(request: ReviewRequest) {
    this.isrequestCreating = true;
    this.createRequestSubscription= this.service.createReviewRequest(request).subscribe({
      next: (request) => { this.isRequestCreatedSuccessfully = true; },
      error: (err) => { this.isError = true; this.errorMessage = err.error; this.isrequestCreating = false; this.submitted = false; },
      complete: () => { this.isTaskLoading = false; this.isrequestCreating = false; this.submitted = false; }
    });
  }
}
